import classNames from 'classnames'
import { t } from 'i18next'

export interface IDoNotOfferErrorMsg {
    className?: string
    province: string
}

const DoNotOfferErrorMsg: React.FC<IDoNotOfferErrorMsg> = ({
    className,
    province,
}) => {
    return (
        <div
            className={classNames(
                className,
                'flex justify-center items-center'
            )}
        >
            <p className="text-left text-red-600">
                {t('weDontOfferError')}{' '}
                {province}.
            </p>
        </div>
    )
}

export default DoNotOfferErrorMsg
